import { useState, useEffect, React, useRef } from "react";
import { Link, useLocation} from "react-router-dom";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import * as C from './styles.js'

//swiper slide
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import Load from "../../../../../../../components/load/index.js";
import { FaArrowLeft, FaXmark } from "react-icons/fa6";
import Crew from "./componentes/crew/index.js";
import Cast from "./componentes/cast/index.js";

export default function Episode( { linkBase, movie_data, movie_type, movie_id, movie_id_imdb } ) {

    const container = useRef();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const season_number = queryParams.get('temporada');
    const episode_number = queryParams.get('episodio');
    
    const [ background, setBackground ] = useState();

    const [ loading, setLoading ] = useState(true);
    const [ episode, setEpisode ] = useState();

    useEffect(()=>{
        
        setLoading(true);
      
        fetch(`https://api.themoviedb.org/3/tv/${movie_id}/season/${season_number}/episode/${episode_number}?api_key=${process.env.REACT_APP_TMDB_KEY}&language=pt-BR`)
            .then(Response => Response.json())
            .then(data => {

            setEpisode(data);
            console.log(data)
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            
        });

        document.getElementById('container').scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, [ movie_id, season_number, episode_number ])
    
    const mesesEN = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const mesesPT = ['Jan', 'Fev', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    function dataConvert(data) {
        // Converte a string de data para um objeto Date
        const dataObj = new Date(data);
      
        // Obtém o mês do objeto Date
        const mes = dataObj.getMonth();

        return `${dataObj.getDate() + 1} de ${mesesPT[mes]} de ${dataObj.getFullYear()}`;
    }

    return(
      <C.Container ref={container} id="container" still_path={episode?.still_path}>
        {loading && <Load align_center={true}/>}
        {(season_number && episode_number && !loading) &&
            <div className="content-movie-assistir">
                <header className="header-bts-back">
                    <Link to={`${linkBase}?detalhes=temporadas&temporada=${season_number}`}><FaArrowLeft size={20} color='#fff'/></Link>
                    <Link to={`${linkBase}`}><FaXmark size={20} color='#fff'/></Link>
                </header>
                <div className="movie-assistir">
                    <div className="detalhes-movie-assistir">
                    <div className="div-img-background-mobile">
                    <img src={episode?.still_path ? `https://image.tmdb.org/t/p/w780${episode?.still_path}` : "https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-38-picture-grey-c2ebdbb057f2a7614185931650f8cee23fa137b93812ccb132b9df511df1cfac.svg"} alt="background image"/>
                        <div className='header-details-movie'>
                        <span className="span-assistir-filmes-series">Episódio {episode_number}</span>
                        <div className="div-title">
                            <h1 className="titulo-movie-assistir"><span>{episode?.name}</span></h1>
                        </div>
                        <h5 className="h5-titulo-movie">{movie_data?.name}</h5>
                        </div>
                    </div>
                    <div className="div-padding-detalhes-movie-mobile">
                        <div className="informacoes-movie-assistir">
                        <Swiper
                            slidesPerView={'auto'}
                            spaceBetween={10}
                            freeMode={false}
                            pagination={{
                                clickable: true,
                            }}
                        >
                            {episode?.air_date &&
                                <SwiperSlide>
                                    <Tippy content={dataConvert(episode && (episode?.air_date))}>
                                        <section>
                                            {episode?.air_date &&
                                                <span>{episode?.air_date.slice(0,4)}</span>
                                            }
                                        </section>
                                    </Tippy>
                                </SwiperSlide>
                            }
                            {episode?.vote_average > 0 &&
                                <SwiperSlide>
                                    <Tippy content='Avaliações'>
                                        <section>
                                            <span><i className="fas fa-star"></i> {episode?.vote_average && (episode?.vote_average).toFixed(1)}<small>/10</small></span>
                                        </section>
                                    </Tippy>
                                </SwiperSlide>
                            }
                            {(movie_type == 'tv' && episode?.episodes?.length) &&
                                <SwiperSlide>
                                    <Tippy content={`${episode?.episodes?.length} Episódios`}>
                                        <section className="section-temporadas">
                                            <span>{episode?.episodes?.length} Episódios</span>
                                        </section>
                                    </Tippy>
                                </SwiperSlide>
                            }
                        </Swiper>
                    </div>
                    <p className="descricao-movie-assistir">{episode?.overview != '' ? episode?.overview : movie_data?.overview}</p>
                    <div className="generos-movie-assistir">
                        <Swiper
                            slidesPerView={'auto'}
                            spaceBetween={10}
                            freeMode={false}
                            pagination={{
                            clickable: true,
                            }}
                        >
                            {movie_data?.genres &&
                                movie_data?.genres?.map((genero, key) => {
                                    return(
                                        <SwiperSlide key={key}>
                                            <Tippy>
                                                <Link to={`/${movie_type}/genero=${genero?.id}/${genero?.name}&infantil=false&pagina=1`}>{genero?.name}</Link>
                                            </Tippy>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                    </div>
                </div>  
                </div>
            </div>
            <Cast cast={episode?.guest_stars}/>
            <Crew crew={episode?.crew}/>
            </div>
        }
      </C.Container>
    )
}